module.exports = __webpack_public_path__ + "static/media/Theodore Roosevelt - 1912.133cd170.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Theodore Roosevelt - 1912.jpg
// module id = 550
// module chunks = 0